document.addEventListener("DOMContentLoaded", function() {
    
    const splideReviewsHomepage = new Splide('.reviews-container__splide.splide', {
        perPage: 3,
        gap: 15,
        arrows: true,
        perMove: 1,
        breakpoints: {
            780: {
                perPage: 1,
                perMove: 1,
            },
      }
    });
    splideReviewsHomepage.mount();


});
